export type AchievementType =
  | "first_match"
  | "winning_debut"
  | "first_friend"
  | "league_master"
  | "hot_streak"
  | "league_join"
  | "friend_request_sent"
  | "friend_request_accepted"
  | "matches_10"
  | "matches_50"
  | "matches_100"
  | "wins_10"
  | "wins_50"
  | "hot_streak_5"
  | "comeback_king"
  | "bagel"
  | "flawless_match"
  | "night_owl"
  | "early_bird"
  | "weekend_warrior"
  | "social_butterfly"
  | "league_podium"
  | "league_champion"
  | "rivalry";

export interface AchievementCatalogEntry {
  title: string;
  description: string;
  iconKey: string;
  color: string;
}

export const ALL_ACHIEVEMENT_TYPES: AchievementType[] = [
  "first_match",
  "winning_debut",
  "first_friend",
  "hot_streak",
  "league_join",
  "league_master",
  "friend_request_sent",
  "friend_request_accepted",
  "matches_10",
  "matches_50",
  "matches_100",
  "wins_10",
  "wins_50",
  "hot_streak_5",
  "comeback_king",
  "bagel",
  "flawless_match",
  "night_owl",
  "early_bird",
  "weekend_warrior",
  "social_butterfly",
  "league_podium",
  "league_champion",
  "rivalry",
];

export const ACHIEVEMENT_CATALOG: Record<AchievementType, AchievementCatalogEntry> = {
  first_match: {
    title: "Primer Partido",
    description: "Registra tu primer partido",
    iconKey: "trophy",
    color: "from-blue-500 to-blue-600",
  },
  winning_debut: {
    title: "Debut Ganador",
    description: "Gana tu primer partido",
    iconKey: "star",
    color: "from-yellow-500 to-yellow-600",
  },
  first_friend: {
    title: "Primer Amigo",
    description: "Acepta tu primera solicitud de amistad",
    iconKey: "heart",
    color: "from-pink-500 to-pink-600",
  },
  hot_streak: {
    title: "Racha Caliente",
    description: "Gana 3 partidos consecutivos",
    iconKey: "flame",
    color: "from-orange-500 to-orange-600",
  },
  league_join: {
    title: "Miembro de Liga",
    description: "Únete a una liga",
    iconKey: "crown",
    color: "from-purple-500 to-purple-600",
  },
  league_master: {
    title: "Maestro de Liga",
    description: "Termina #1 al cerrarse una temporada",
    iconKey: "crown",
    color: "from-amber-500 to-amber-600",
  },
  friend_request_sent: {
    title: "Solicitud Enviada",
    description: "Envía una solicitud de amistad",
    iconKey: "user-plus",
    color: "from-cyan-500 to-cyan-600",
  },
  friend_request_accepted: {
    title: "Amistad Confirmada",
    description: "Acepta una solicitud de amistad",
    iconKey: "check-circle",
    color: "from-emerald-500 to-emerald-600",
  },
  matches_10: {
    title: "Veterano",
    description: "Juega 10 partidos",
    iconKey: "trophy",
    color: "from-sky-500 to-sky-600",
  },
  matches_50: {
    title: "Centurión",
    description: "Juega 50 partidos",
    iconKey: "medal",
    color: "from-indigo-500 to-indigo-600",
  },
  matches_100: {
    title: "Leyenda de la Pista",
    description: "Juega 100 partidos",
    iconKey: "award",
    color: "from-violet-500 to-violet-600",
  },
  wins_10: {
    title: "Ganador Habitual",
    description: "Consigue 10 victorias",
    iconKey: "trending-up",
    color: "from-lime-500 to-lime-600",
  },
  wins_50: {
    title: "Dominador",
    description: "Consigue 50 victorias",
    iconKey: "trending-up",
    color: "from-green-600 to-green-700",
  },
  hot_streak_5: {
    title: "En Llamas",
    description: "Gana 5 partidos consecutivos",
    iconKey: "zap",
    color: "from-red-500 to-orange-500",
  },
  comeback_king: {
    title: "Remontada Épica",
    description: "Gana un partido tras perder el primer set",
    iconKey: "repeat",
    color: "from-fuchsia-500 to-fuchsia-600",
  },
  bagel: {
    title: "Rosco",
    description: "Gana un set 6-0",
    iconKey: "target",
    color: "from-rose-500 to-rose-600",
  },
  flawless_match: {
    title: "Partido Perfecto",
    description: "Gana 6-0, 6-0",
    iconKey: "star",
    color: "from-amber-400 to-yellow-500",
  },
  night_owl: {
    title: "Búho Nocturno",
    description: "Juega un partido después de las 22:00",
    iconKey: "moon",
    color: "from-slate-600 to-slate-800",
  },
  early_bird: {
    title: "Madrugador",
    description: "Juega un partido antes de las 9:00",
    iconKey: "sunrise",
    color: "from-orange-300 to-amber-500",
  },
  weekend_warrior: {
    title: "Guerrero de Finde",
    description: "Juega sábado y domingo de la misma semana",
    iconKey: "calendar-days",
    color: "from-teal-500 to-teal-600",
  },
  social_butterfly: {
    title: "Mariposa Social",
    description: "Consigue 5 amistades aceptadas",
    iconKey: "users",
    color: "from-pink-400 to-rose-500",
  },
  league_podium: {
    title: "Podio",
    description: "Termina top 3 en una liga cerrada",
    iconKey: "medal",
    color: "from-amber-500 to-orange-600",
  },
  league_champion: {
    title: "Campeón de Liga",
    description: "Gana una liga (termina #1 al cerrarse)",
    iconKey: "trophy",
    color: "from-yellow-400 to-amber-600",
  },
  rivalry: {
    title: "Rivalidad",
    description: "Juega 5 partidos contra el mismo oponente",
    iconKey: "repeat",
    color: "from-stone-500 to-stone-700",
  },
};
